<template>
<div class="columns is-multiline" style="margin-bottom: 1px;">
    <div class="column is-12">
        <div class="field">
            <input v-model="name" @keyup.enter="createAccount" name="custom-schedule" type="text" :disabled="creatingAccount" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Account name" autocomplete="off"/>
            <span v-if="!hasError('name')" class="help">An intuitive name to easily recognize the account later.</span>
            <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
        </div>
    </div>
    <div class="column is-12">
        <div class="field">
            <div class="control has-icons-left">
                <div class="select is-fullwidth">
                    <select v-model="locationKey" :disabled="creatingAccount" name="ovh-location">
                        <option v-for="location in locations" :value="location.key" v-bind:key="location.key">{{ location.name }}</option>
                    </select>
                </div>
                <div class="icon is-left is-custom-icon-left">
                    <font-awesome-icon icon="globe-americas"/>
                </div>
            </div>
        </div>
        <span class="help" style="display: inline-block; margin-top: 6px;">The location of your OVH account.</span>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            name: '',
            locationKey: 'ovh-eu',
            allowedInputs: ['name'],
            error: '',
            creatingAccount: false,
            locations: [
                {
                    key: 'ovh-eu',
                    name: 'OVH Europe (eu.ovh.com)',
                }, 
                {
                    key: 'ovh-us',
                    name: 'OVH US (us.ovh.com)',
                }, 
                {
                    key: 'ovh-ca',
                    name: 'OVH North America (ca.ovh.com)',
                }, 
            ],
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        createAccount() {
            if (this.creatingAccount) {
                return;
            }

            this.creatingAccount = true;
            this.resetErrors();

            Api().post('accounts', this.newAccountData)
                .then(response => {
                    // localStorage.accountPendingAssociation = JSON.stringify({
                    //    id: response.data.account.id,
                    //    created_at: response.data.account.created_at,
                    // });
                    window.location.href = response.data.authorization_url;
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                    this.creatingAccount = false;
                })
                .finally(() => {
                    //
                });
        },

        listenEvents() {
            let vm = this;

            Event.$on('createProviderAccount', (providerSlug) => {
                if (providerSlug == 'ovh') {
                    vm.createAccount();
                }
            });

            Event.$on('addAccountClosed', () => {
                this.resetErrors();
                this.name = '';
                this.error = '';
            });
        },
    },

    computed: {
        newAccountData() {
            return {
                provider_slug: 'ovh',
                name: this.name,
                ovh_location: this.locationKey,
            }
        },
    },

    watch: {
        creatingAccount(creatingAccount) {
            Event.$emit('creatingAccountLoaderUpdated', creatingAccount);
        }
    },
}
</script>
